import type { StackTowerConfig } from './rules.ts';
import type { TowerRunState } from './tower-state.ts';
import { zoneForHeight } from './zones.ts';

/** The game-over/leaderboard-submission summary (spec §69, §85). */
export interface StackTowerRunResult {
  runId: string;
  score: number;
  perfectCount: number;
  maxPerfectStreak: number;
  perfectPercentage: number;
  /** Final block width as a fraction of the starting width — matches spec §85's normalised convention (e.g. `0.18` for "down to 18% of the original block"). */
  finalWidthFraction: number;
  zoneId: string;
  averagePlacementOffset: number;
  smallestOverlapSize: number | null;
  runDurationMs: number;
}

export function deriveRunResult(
  state: TowerRunState,
  config: StackTowerConfig,
  startedAtMs: number,
  endedAtMs: number,
): StackTowerRunResult {
  return {
    runId: state.runId,
    score: state.score,
    perfectCount: state.perfectCount,
    maxPerfectStreak: state.maxPerfectStreak,
    perfectPercentage: state.placementCount > 0 ? (state.perfectCount / state.placementCount) * 100 : 0,
    finalWidthFraction: state.movingBlockWidth / config.startingBlockWidth,
    zoneId: zoneForHeight(state.climbBlocks).id,
    averagePlacementOffset: state.placementCount > 0 ? state.offsetSum / state.placementCount : 0,
    smallestOverlapSize: state.smallestOverlapSize,
    runDurationMs: Math.max(0, endedAtMs - startedAtMs),
  };
}
